import React from 'react';
import { withAuthDomain } from '../../components/Session';
import { makeStyles ,withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import withWidth from '@material-ui/core/withWidth';
import {Grid, Paper } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Slider from '@material-ui/core/Slider';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import CircularProgress from '@material-ui/core/CircularProgress';
//import ListItemText from '@material-ui/core/ListItemText';
//import ListItem from '@material-ui/core/ListItem';
//import List from '@material-ui/core/List';
//import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
//import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';

import CloseIcon from '@material-ui/icons/Close';
import Tooltip from '@material-ui/core/Tooltip';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import StarIcon from '@material-ui/icons/StarBorder';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Divider from '@material-ui/core/Divider';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';
import Accordion  from '@material-ui/core/Accordion';
import Clock,{twoDigits,toSimpleDateTimestamp,convertMonthToName} from '../../components/Fragment/Clock.js'
//import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles(theme => ({
  root: {
    overscrollBehavior: "contain",
    maxWidth:"100vw",
    minHeight:"89vh",
    overflow:"auto",
    margin:"0px",
    padding:"0px",
    paddingBottom:"70px",
    position:"relative",
    userSelect:"none", 
  },
  paper:{
    margin:"10px",
    padding:"20px",
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '80%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  calculatorAppBar: {
    position: 'sticky',
    top:'0',
  },
  calculatorTitle: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  table: {
    minWidth: 250,
  },
}));

const CompanyBillingsPage = (props) => {
  const {
    firebase,
    currentUser,
    companyView,
    branchView,
    employeeData,
    sessionDomain,
    domainExpirationStatus,
    featureStatus,
    errorPosition,
    
    width,
    currentDate,
    serverMillis,
    serverClockStatus,
    activeCompany,
    
    //...otherProps
  }=props
  const classes = useStyles();
  const [companyBillings,setCompanyBillings]=React.useState()
  const [branchList,setBranchList]=React.useState([])
  const [openComparePricing,setOpenComparePricing]=React.useState(false)
  
  const [openPricingCalculator,setOpenPricingCalculator]=React.useState(false)
  const [updatingLevel,setUpdatingLevel]=React.useState(false)
  
  
  React.useEffect(()=>{
    setBranchList([])
    if(!!activeCompany){
      return firebase.fs.collection("companies/"+activeCompany.id+"/branches").onSnapshot((querySnapshot) => {
        var branches = [];
        querySnapshot.forEach(function(doc) {
          branches.push(doc.data());
        });
        setBranchList(branches)
      },(e)=>{
        console.log("error get branch list"+e)
      })
    }
  },[activeCompany])

  React.useEffect(()=>{
    setCompanyBillings(null)
    if(!!activeCompany){
      return firebase.fs.doc("billings/"+activeCompany.id).onSnapshot((doc) => {
        setCompanyBillings(doc.data())
      },(e)=>{
        console.log("error get company billings "+e)
      })
    }
  },[activeCompany])

  function handleUpdatePro(){
    var setBillingsPlanLevel = firebase.fn.httpsCallable('setBillingsPlanLevel')
    setUpdatingLevel(true)
    setOpenPricingCalculator(false)
    setBillingsPlanLevel({
      planLevel:"PRO",
      companyId:activeCompany.id,
    }).then((result)=>{
      setUpdatingLevel(false)
    }).catch(e=>{
      setUpdatingLevel(false)
      window.alert("Gagal : "+e)
    })
  }
  

  return (
    <div className={classes.root}>
      {sessionDomain>=1&&!!activeCompany&&
        <Grid container direction={width==="xs"?"column":"row"} justify={width==="xs"?"center":"flex-start"} alignItems={width==="xs"?"stretch":"flex-start"}>

          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"50px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5" style={{width:"100%",marginBottom:"50px"}}>
                <span style={{float:"left",fontSize:"14px"}}>{!!companyBillings&&<>{updatingLevel?"Memperbarui...":<PlanLevelBadge plan={companyBillings.planLevel} style={{float:"left"}} size="medium"/>}</>}<br/>Level Billing</span>
                {!!companyBillings&&<Button style={{float:"right"}} disabled={updatingLevel} variant="contained" color="primary" onClick={()=>setOpenComparePricing(true)}>{companyBillings.planLevel==="PRO"?"AKTIF":"Upgrade"}</Button>}
                &nbsp;
              </Typography>
              {!!companyBillings&&<Typography variant="subtitle2" style={{clear:"both",marginTop:"15px"}}>{companyBillings.planLevel==="FREE"||companyBillings.planLevel==="BASIC"?<span>{companyBillings.planLevel==="BASIC"?"Level Basic memungkinkan Anda untuk mencapai target omzet 50 juta rupiah atau 500 transaksi tiap bulannya. Dapatkan diskon kuota omzet sampai dengan 50 juta tiap bulan dengan UPGRADE menjadi level PRO":"Awali keberhasilanmu dimulai dari FREE. Dengan level FREE, Kami memastikan Anda bisa untuk dapat menjelajahi dan mengambil manfaat layanan Online Asset Manager untuk merintis / menjalankan usaha hingga memperoleh omzet penjualan mencapai 10 juta rupiah atau 100 transaksi penjualan per bulan tanpa biaya apapun. Tombol UPGRADE BASIC / PRO tersedia untukmu sebagai tolak ukur bahwa usahamu telah siap untuk melebarkan sayapnya dan didukung dengan fitur-fitur premium."}<br/><Button variant="outlined" color="secondary" disabled={updatingLevel} onClick={()=>{setOpenPricingCalculator(true)}}>LIHAT KALKULATOR TARIF</Button><br/><br/>Anda bisa UPGRADE ataupun DOWNGRADE levelmu kapan saja.<br/>Akan tetapi perlu diketahui bahwa tidak ada pengembalian dana prorata atas downgrade atau pembatalan level. Artinya, jika Anda downgrade atau membatalkan sebelum akhir periode penagihan sedangkan Anda masih memiliki sisa tagihan pada bulan sebelumnya atau bulan berjalan, maka downgrade atau pembatalan akan efektif untuk bulan berikutnya dan Anda masih perlu untuk membayar sisa tagihan penggunaan pada bulan tersebut.</span>:"Sistem manajemen online terbaik kini ada di tangan Anda"}</Typography>}
            </Paper>
          </Grid>

          {branchList.map((branch,idx)=>{
            return (
              <BranchBillings key={branch.id||idx} {...props} branch={branch} idx={idx} companyBillings={companyBillings} />
            )
          })}
        </Grid>
      }
      <CalculatorPricingDialog open={openPricingCalculator} width={width} onClose={()=>{setOpenPricingCalculator(false)}} selectedTier={!!companyBillings?companyBillings.planLevel:"FREE"} onRequestPro={handleUpdatePro}/>
      <ComparePricingDialog firebase={firebase} activeCompany={activeCompany} selectedTier={!!companyBillings?companyBillings.planLevel:"FREE"} open={openComparePricing} onClose={()=>setOpenComparePricing(false)}/>
    </div>
  )
}

function BranchBillings(props){
  const {
    firebase,
    currentUser,
    companyView,
    branchView,
    employeeData,
    sessionDomain,
    domainExpirationStatus,
    featureStatus,
    errorPosition,
    
    width,
    currentDate,
    serverMillis,
    serverClockStatus,
    activeCompany,

    branch,
    idx,
    companyBillings,
    
    //...otherProps
  }=props
  const classes = useStyles();
  const [branchBillings,setBranchBillings]=React.useState()
  const [historyBillings,setHistoryBillings]=React.useState([])
  
  const [currentBillsDate,setCurrentBillsDate]=React.useState("")
  
  React.useEffect(()=>{
    var arr=currentDate.split("/")
    setCurrentBillsDate(arr[0]+arr[1])
  },[currentDate])
  

  React.useEffect(()=>{
    setBranchBillings(null)
    if(!!companyBillings&&!!branch){
      return firebase.fs.doc("billings/"+companyBillings.id+"/branchBillings/"+branch.id).onSnapshot((doc) => {
        setBranchBillings(doc.data())
      },(e)=>{
        console.log("error get branch billings "+e)
      })
    }
  },[companyBillings,branch])

  React.useEffect(()=>{
    setHistoryBillings([])
    if(!!companyBillings&&!!branch){
      return firebase.fs.collection("billings/"+companyBillings.id+"/branchBillings/"+branch.id+"/monthlyBills").orderBy("id","desc").limit(6).onSnapshot((querySnapshot) => {
        var usages = [];
        querySnapshot.forEach(function(doc) {
          if(currentBillsDate===doc.id&&!doc.data().statusBills){
            var obj=doc.data()
            obj.statusBills="Estimasi Tagihan"
            usages.push(obj);
          }else{
            usages.push(doc.data());
          }
          
        });
        setHistoryBillings(usages)
      },(e)=>{
        console.log("activeCompany.id="+activeCompany.id)
        console.log("companyBillings.id="+companyBillings.id)
        console.log("branch.id="+branch.id)
        
        console.log("error get branch billings "+e)
      })
    }
  },[companyBillings,branch,currentBillsDate])

  


  /*

              <Typography className={classes.heading} style={{flexBasis:width==="xs"?"40%":"80%"}}>{branchBillings.statusBills}<br/>Berlaku sampai : {toSimpleDateTimestamp(parseInt(branchBillings.dueDateBills))}</Typography>
              <Typography className={classes.secondaryHeading}>{branchBillings.activeBills===0?"FREE":numberToRupiah(branchBillings.activeBills)}</Typography>
              

  */


  return (
    <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
      <Paper elevation={3} className={classes.paper} style={{minHeight:"100px",width:width==="xs"?"95%":"98%%"}}>
        <Typography variant="h5">
          {branch.name}{width==="xs"?<br/>:null}
        </Typography>
        <br/>
        {historyBillings.length===0?
          "Belum ada tagihan"
        :
          historyBillings.map((usage,index)=>
            <DetailUsage
              firebase={firebase}
              serverMillis={serverMillis}
              key={usage.id||index}
              width={width} 
              companyBillings={companyBillings}
              branchBillings={branchBillings}
              index={index}
              usage={usage}/>
          )
        }
        
      </Paper>
    </Grid>
  )
}

function DetailUsage(props){
  const {
    firebase,
    index,
    serverMillis,
    companyBillings,
    branchBillings,
    usage,
    width,
    
    //...otherProps
  }=props
  const classes = useStyles();
  const [expandedUsages,setExpandedUsages]=React.useState(false)
  const [expandedSummary,setExpandedSummary]=React.useState(true)

  const [uploading,setUploading]=React.useState(false)
  const [imageURL,setImageURL]=React.useState("")
  
  const [progressUpload,setProgressUpload]=React.useState(-1)

  function uploadFile(ev,finishCallback){
    var pathStorageRef="billings/"+companyBillings.id+"/"+branchBillings.id+"/buktiBayar/"+usage.yearBills+"/"+usage.monthBills+"/"
    if(!firebase||!pathStorageRef){
      alert("Tidak bisa upload")
      return
    }
    var fileObj=ev.target.files[0]
    console.log("Upload "+fileObj)
    if(fileObj){
      //if(!!onStartUpload)onStartUpload(fileObj)
      //inputElem.disabled=true
      setUploading(true)
      setProgressUpload(0)
      console.log("Uploading... "+fileObj.name+" "+fileObj.type)//VID-20190513-WA0001.mp4 video/mp4
      var uploadTask = firebase.st.ref().child(pathStorageRef+fileObj.name).put(fileObj)
      uploadTask.on('state_changed', // or 'state_changed'
        function(snapshot) {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = Math.trunc((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
          console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case 'paused': // or 'paused'
              console.log('Upload is paused');
              break;
            case 'running': // or 'running'
              console.log('Upload is running');
              break;
          }
          setProgressUpload(Math.trunc(progress*0.8))
          //if(!!onProgressUpload)onProgressUpload(progress)
        }, function(error) {
        //inputElem.disabled=false
        console.log('Upload error '+error.code);
        switch (error.code) {
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
      
          case 'storage/canceled':
            // User canceled the upload
            break;
      
          case 'storage/unknown':
            // Unknown error occurred, inspect error.serverResponse
            break;
        }
        //if(!!onErrorUpload)onErrorUpload(error)
      }, function() {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          console.log('File available at', downloadURL);
          setProgressUpload(90)
          var addBuktiBayarLink = firebase.fn.httpsCallable('addPaymentLink')
          addBuktiBayarLink({
            companyId:companyBillings.id,
            branchId:branchBillings.id,
            yearBills:usage.yearBills,
            monthBills:usage.monthBills,
            paymentLink:downloadURL,
          }).then((result)=>{
            setProgressUpload(100)
            setUploading(false)
            finishCallback(downloadURL)
          }).catch(e=>{
            setUploading(false)
            window.alert("Gagal : "+e)
            finishCallback(downloadURL)
          })

        });
      });
    }else{
      console.log("Cancel Upload")
    }
  }

  
  var planLevel=usage.planLevel||""
  
  return (
  <Accordion expanded={expandedUsages} onChange={()=>{setExpandedUsages(!expandedUsages)}}
    style={{
      backgroundColor:usage.statusBills==="LUNAS"?"rgb(225,255,225)":usage.statusBills==="Menunggu Pembayaran"?"rgb(252,252,208)":(usage.statusBills==="Proses Verifikasi"||usage.statusBills==="Estimasi Tagihan")?"#e0e0e0":"#fb85a8",
      borderColor:usage.statusBills==="LUNAS"?"rgb(0,244,0)":usage.statusBills==="Menunggu Pembayaran"?"rgb(247,241,13)":(usage.statusBills==="Proses Verifikasi"||usage.statusBills==="Estimasi Tagihan")?"#888888":"rgb(231,45,12)",
      borderRadius: expandedUsages?"10px":"0px",
      borderStyle:"solid",
    }}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
    >
      <div style={{width:"100%"}}>
        <div style={{float:"left",clear:"both",fontSize:width==="xs"?"22px":"20px",fontWeight:"bold",width:width==="xs"?"100%":"auto",textAlign:"left"}}>{convertMonthToName(parseInt(usage.monthBills))} {usage.yearBills}</div>
        {!expandedUsages&&<span style={{float:width==="xs"?"left":"right",clear:width==="xs"?"both":"right",fontWeight:"bold",fontSize:width==="xs"?"16px":"20px"}}>{usage.statusBills}</span>}
        {(usage.statusBills!=="LUNAS"&&usage.statusBills!=="Estimasi Tagihan"&&usage.statusBills!=="Proses Verifikasi"&&!!usage.rejectedReason)&&<span style={{float:width==="xs"?"left":"right",clear:width==="xs"?"both":"right",color:"red"}}><b>{usage.rejectedReason}</b></span>}
        {(!expandedUsages&&usage.statusBills!=="LUNAS"&&usage.statusBills!=="Estimasi Tagihan"&&usage.statusBills!=="Proses Verifikasi"&&!!usage.dueDateBills)&&<span style={{float:"left",clear:width==="xs"?"both":"left"}}><i>Jatuh tempo : {toSimpleDateTimestamp(parseInt(usage.dueDateBills))}</i></span>}
        <span style={{float:"right",clear:"both",fontWeight:"bold",fontSize:"20px"}}>{!usage.amountBills?"FREE":numberToRupiah(usage.amountBills)}</span>
        <PlanLevelBadge plan={planLevel} style={{float:"left",clear:"left",}}/>
      </div>
    </AccordionSummary>
    <AccordionDetails>
      <div style={{width:"100%"}}>
        <Divider style={{marginBottom:"10px"}}/>
        <Typography variant="h5" style={{textAlign:"center",fontWeight:"bold"}}>
          {usage.statusBills}<br/>
          {!usage.amountBills?"FREE":numberToRupiah(usage.amountBills)}<br />
          {(usage.statusBills!=="LUNAS"&&usage.statusBills!=="Estimasi Tagihan"&&!!usage.dueDateBills)&&<span style={{fontSize:"16px"}}><i>Jatuh tempo : {toSimpleDateTimestamp(parseInt(usage.dueDateBills))}</i></span>}
        </Typography>
        {(!usage.paymentLink&&usage.statusBills!=="LUNAS"&&usage.statusBills!=="Estimasi Tagihan"&&usage.planLevel!=="FREE")&&
          <Accordion style={{marginBottom:"2px",marginTop:"15px"}} expanded={expandedSummary} onChange={()=>{setExpandedSummary(!expandedSummary)}}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography variant="h6" style={{textAlign:"left"}}>
                Cara Pembayaran
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="subtitle1" style={{textAlign:"left"}}>
                Pembayaran tagihan dapat dilakukan dengan cara transfer bank sejumlah {!usage.amountBills?"FREE":numberToRupiah(usage.amountBills)} ke nomor rekening :<br/>
                <b style={{fontSize:"20px"}}>BCA : Febri Widhawanto<br/>0480927958</b>
                <br/><i>atau</i><br/>
                <b style={{fontSize:"20px"}}>BNI : Febri Widhawanto<br/>0834890368</b><br/>
                Lalu kirimkan foto bukti bayar atau screenshot bukti bayar dari m-Banking melalui tombol "UPLOAD BUKTI BAYAR"
              </Typography>
            </AccordionDetails>
          </Accordion>
        }
        
        
        {(!!usage.paymentLink&&usage.statusBills!=="LUNAS"&&usage.statusBills!=="Estimasi Tagihan"&&usage.planLevel!=="FREE")&&
          <div style={{textAlign:"center"}}>
            <img width={width==="xs"?"100%":"320px"} height="auto" style={{objectFit: "contain",border:"1px solid black"}} src={usage.paymentLink} alt={usage.paymentLink}/>
            {!!usage.rejectedReason&&usage.statusBills==="Menunggu Pembayaran"?
              <Typography variant="subtitle1" >
                {usage.rejectedReason}
              </Typography>
            :
              <Typography variant="subtitle1" >
                Bukti bayar Anda sedang diverifikasi oleh admin Kami. Status pembayaran akan Kami informasikan lebih lanjut via email paling lambat 1x24 jam. Terimakasih
              </Typography>
            }
          </div>
        }

        {((!usage.paymentLink&&progressUpload>=0)||uploading)&&
          <div style={{textAlign:"center"}}>
            <CircularProgress size={100} variant={progressUpload===0?"indeterminate":"determinate"} value={progressUpload} />
          </div>
        }

        {(usage.statusBills!=="LUNAS"&&usage.statusBills!=="Estimasi Tagihan"&&usage.planLevel!=="FREE")&&
          <div style={{textAlign:"center"}}>
            <br/>
            <input accept="image/*" style={{display:"none"}} id={"imageUpload"+index} type="file" onChange={ev=>uploadFile(ev,setImageURL)}/>
            <label htmlFor={"imageUpload"+index}>
              <Button variant={!!usage.paymentLink?"outlined":"contained"} color="secondary" component="span">
                {!!usage.paymentLink?"Upload Ulang":"Upload Bukti Bayar"}
              </Button>
            </label>
            <Divider style={{marginTop:"10px"}}/>
          </div>
        }
        
        
        {(usage.planLevel!=="PRO"||usage.statusBills==="Estimasi Tagihan")&&
          <PricingNonProDetail usage={usage} width={width}/>
        }
        {usage.planLevel==="PRO"&&
          <PricingProDetail usage={usage} width={width}/>
        }
      </div>
    </AccordionDetails>
  </Accordion>
)
}

function PlanLevelBadge(props){
  const {
    plan,
    style,
    size="small"
  }=props
  
  return (
    <span style={{
      //float:"left",
      //clear:"left",
      fontSize:size==="small"?"12px":"16px",
      width:size==="small"?"60px":"110px",
      textAlign:"center",
      margin:"2px",
      fontFamily:"Arial",
      fontWeight:"bold",
      border:"1px solid black",
      padding:size==="small"?"2px":"6px",
      color:plan==="FREE"?"white":plan==="BASIC"?"white":plan==="PRO"?"black":"white",
      backgroundColor:plan==="FREE"?"green":plan==="BASIC"?"blue":plan==="PRO"?"gold":"red",
      ...style,
    }}>{!plan?"BANNED":plan}</span>
  )
}

function PricingNonProDetail(props){
  const {
    onChange,
    usage,
    width,
  }=props
  const classes = useStyles();

  
  const markOmzet = [
    {
      value: 0,
      label: '0',
    },
    {
      value: 10000000,
      label: 'FREE',
    },
    {
      value: 50000000,
      label: 'BASIC',
    },
  ];
  const marks = [
    {
      value: 0,
      label: '0',
    },
    {
      value: 100,
      label: 'FREE',
    },
    {
      value: 500,
      label: 'BASIC',
    },
  ];

  function getSimplifiedNumberFormat(value) {
    if(value>=1000&&value<999999){
      return Math.trunc(value/1000)+"K"
    }else if(value>=1000000&&value<999999999){
      return Math.trunc(value/1000000)+"Jt"
    }else{
      return value||0;
    }
  }

  var usageTransactionSell=usage.usageTransactionSell||0
  var usageTurnOver=usage.usageTurnOver||0
  var planLevel=usage.planLevel||""
  return (
    <>
      <Typography variant="h6" style={{marginBottom:"10px"}}>
        Penggunaan Kuota : {planLevel}
      </Typography>
      <div>
        <div>
          <span style={{float:"left",width:"50%",fontSize:"16px",fontWeight:"bold"}}>Omzet</span>
          <span style={{float:"right",width:"50%",fontSize:"24px",textAlign:"right"}}>{planLevel==="FREE"?(Math.trunc((usageTurnOver*100)/10000000)+"%"):planLevel==="BASIC"?(Math.trunc(usageTurnOver*100/50000000)+"%"):planLevel==="PRO"?"Unlimited":null}</span>
          <PrettoSlider valueLabelFormat={getSimplifiedNumberFormat} style={{clear:"both",width:"100%"}} valueLabelDisplay="auto" marks={markOmzet} max={planLevel==="FREE"||planLevel==="BASIC"?50000000:usageTurnOver<=100000000?100000000:usageTurnOver} aria-label="pretto slider" value={usageTurnOver} />
          &nbsp;
        </div>
      </div>
      <div>
        <div>
          <span style={{float:"left",width:"50%",fontSize:"16px",fontWeight:"bold"}}>Penjualan</span>
          <span style={{float:"right",width:"50%",fontSize:"24px",textAlign:"right"}}>{planLevel==="FREE"?(Math.trunc((usageTransactionSell*100)/100)+"%"):planLevel==="BASIC"?(Math.trunc(usageTransactionSell*100/500)+"%"):planLevel==="PRO"?"Unlimited":null}</span>
          <PrettoSlider valueLabelFormat={getSimplifiedNumberFormat} style={{clear:"both",width:"100%"}} valueLabelDisplay="auto" marks={marks} max={planLevel==="FREE"||planLevel==="BASIC"?500:usageTransactionSell<=1000?1000:usageTransactionSell} aria-label="pretto slider" value={usageTransactionSell} />
          &nbsp;
        </div>
      </div>
    </>
  )
}

function PricingProDetail(props){
  const {
    expanded,
    onChange,
    usage,
    width,
  }=props
  const classes = useStyles();
  const [basicRate,setBasicRate]=React.useState(0)
  const [basicRateText,setBasicRateText]=React.useState("")
  
  const [usageTurnOver,setUsageTurnOver]=React.useState(0)
  const [usageTurnOverText,setUsageTurnOverText]=React.useState("")
  const [freeTurnOver,setFreeTurnOver]=React.useState(0)
  const [freeTurnOverText,setFreeTurnOverText]=React.useState("")
  const [subsTurnOver,setSubsTurnOver]=React.useState(0)
  const [subsTurnOverText,setSubsTurnOverText]=React.useState("")
  const [priceTurnOver,setPriceTurnOver]=React.useState(0)
  const [priceTurnOverText,setPriceTurnOverText]=React.useState("")
  
  const [usageTransactionSell,setUsageTransactionSell]=React.useState(0)
  const [freeTransactionSell,setFreeTransactionSell]=React.useState(0)
  const [subsTransactionSell,setSubsTransactionSell]=React.useState(0)
  const [subsTransactionSellText,setSubsTransactionSellText]=React.useState("")
  const [priceTransactionSell,setPriceTransactionSell]=React.useState(0)
  const [priceTransactionSellText,setPriceTransactionSellText]=React.useState("")

  const [usageUnitEntry,setUsageUnitEntry]=React.useState(0)
  const [freeUnitEntry,setFreeUnitEntry]=React.useState(0)
  const [subsUnitEntry,setSubsUnitEntry]=React.useState(0)
  const [subsUnitEntryText,setSubsUnitEntryText]=React.useState("")
  const [priceUnitEntry,setPriceUnitEntry]=React.useState(0)
  const [priceUnitEntryText,setPriceUnitEntryText]=React.useState("")

  const [amountBills,setAmountBills]=React.useState(0)
  const [amountBillsText,setAmountBillsText]=React.useState("")

  React.useEffect(()=>{
    if(!!usage){
      

      var usageTO=usage.usageTurnOver
      setUsageTurnOver(usageTO)
      setUsageTurnOverText(numberToRupiah(usageTO))

      var freeTO=usage.usageTurnOver>=50000000?50000000:usage.usageTurnOver
      setFreeTurnOver(freeTO)
      setFreeTurnOverText(numberToRupiah(freeTO))

      var subsTO=usageTO-freeTO
      setSubsTurnOver(subsTO)
      setSubsTurnOverText(numberToRupiah(subsTO))

      var priceTO=Math.trunc(subsTO*0.01)
      setPriceTurnOver(priceTO)
      setPriceTurnOverText(numberToRupiah(priceTO))


      var usageTS=usage.usageTransactionSell
      setUsageTransactionSell(usageTS)

      var freeTS=usage.usageTransactionSell>=500?500:usage.usageTransactionSell
      setFreeTransactionSell(freeTS)

      var subsTS=usageTS-freeTS
      setSubsTransactionSell(subsTS)
      setSubsTransactionSellText(numberToRupiah(subsTS))

      var priceTS=Math.trunc(subsTS*1000)
      setPriceTransactionSell(priceTS)
      setPriceTransactionSellText(numberToRupiah(priceTS))


      var usageUE=usage.usageUnitEntry
      setUsageUnitEntry(usageUE)

      var freeUE=usage.usageUnitEntry>=500?500:usage.usageUnitEntry
      setFreeUnitEntry(freeUE)

      var subsUE=usageUE-freeUE
      setSubsUnitEntry(subsUE)
      setSubsUnitEntryText(numberToRupiah(subsUE))

      var priceUE=Math.trunc(subsUE*1000)
      setPriceUnitEntry(priceUE)
      setPriceUnitEntryText(numberToRupiah(priceUE))

      var BR=usageTO>10000000||usageTS>100||usageUE>100?500000:0
      setBasicRate(BR)
      setBasicRateText(numberToRupiah(BR))

      var calcAB=BR+priceTO+priceTS+priceUE
      //var AB=usage.amountBills
      
      setAmountBills(calcAB)
      setAmountBillsText(numberToRupiah(calcAB))
     

    }
  },[usage])

  const[expandedSummary,setExpandedSummary]=React.useState(false)
  
  //maxWidth:width==="xs"?"260px":"100%",
  return (
    <>
      <Accordion style={{marginBottom:"2px",marginTop:"15px",textAlign:"left"}} expanded={expandedSummary} onChange={()=>{setExpandedSummary(!expandedSummary);if(!!onChange)onChange(expanded)}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography variant="h6" style={{marginBottom:"10px"}}>
            Rincian Tagihan {usage.planLevel}
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{width:width==="xs"?"280px":"100%",overflowX:"auto"}}>
          
        <div >

          <table width="100%" style={{overflowX:"auto",backgroundColor:"white",padding:"20px"}}>
            <tbody>
              <tr style={{verticalAlign:"bottom",whiteSpace:"nowrap"}}>
                <td style={{whiteSpace:"nowrap"}}><b>Tarif Dasar Basic</b></td>
                <td ></td>
                <td ></td>
                <td ></td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>{basicRateText}</td>
              </tr>
              <tr style={{height:"50px",verticalAlign:"bottom",whiteSpace:"nowrap"}}>
                <td><b>Omzet</b></td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>{usageTurnOverText}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>Diskon <i>(max 50jt)</i></td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>{freeTurnOverText}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>Tarif {usage.rateTurnOver}%</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}><Divider style={{backgroundColor:"black"}}/>{subsTurnOverText}</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"left"}}>x {usage.rateTurnOver}%</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>=</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>{priceTurnOverText}</td>
              </tr>
              <tr style={{height:"50px",verticalAlign:"bottom",whiteSpace:"nowrap"}}>
                <td><b>Penjualan</b></td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>{usageTransactionSell}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>Diskon <i>(max 500)</i></td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>{freeTransactionSell}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>Tarif {numberToRupiah(usage.rateTransactionSell)}</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}><Divider style={{backgroundColor:"black"}}/>{subsTransactionSell}</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"left"}}>x {numberToRupiah(usage.rateTransactionSell)}</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>=</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>{priceTransactionSellText}</td>
              </tr>
              <tr style={{height:"50px",verticalAlign:"bottom",whiteSpace:"nowrap"}}>
                <td><b>Unit Entry (**)</b></td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>{usageUnitEntry}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>Diskon <i>(max 500)</i></td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>{freeUnitEntry}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>Tarif {numberToRupiah(usage.rateUnitEntry)}</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}><Divider style={{backgroundColor:"black"}}/>{subsUnitEntry}</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"left"}}>x {numberToRupiah(usage.rateUnitEntry)}</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>=</td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}>{priceUnitEntryText}</td>
              </tr>
              <tr style={{height:"50px",verticalAlign:"bottom",whiteSpace:"nowrap"}}>
                <td><b style={{fontSize:"20px"}}>TOTAL (*)</b></td>
                <td></td>
                <td></td>
                <td></td>
                <td style={{whiteSpace:"nowrap",verticalAlign:"bottom",textAlign:"right"}}><Divider style={{backgroundColor:"black"}}/><b style={{fontSize:"20px"}}>{amountBillsText}</b></td>
              </tr>
            </tbody>
          </table>
          <Typography variant="subtitle2">
            (*) Penggunaan kuota cabang akan ditagihkan pada awal bulan berikutnya<br/>
            (**) Hanya untuk bidang usaha jenis BENGKEL<br/>
          </Typography>
          </div>

        </AccordionDetails>
      </Accordion>
      
      
      
    </>
  )
}

const PrettoSlider = withStyles({
  root: {
    color: '#52af77',
    height: 8,
  },
  thumb: {
    height: 0,
    width: 0,
    backgroundColor: '#fff',
    border: '0px solid currentColor',
    marginTop: 0,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    color:'#ffaa00',
    //backgroundColor:"#ff0000",
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const PrettoSliderActive = withStyles({
  root: {
    color: '#52af77',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ComparePricingDialog(props){
  const {
    firebase,
    activeCompany,
    open,
    width,
    onClose,
    selectedTier,
    //...otherProps
  }=props
  const classes = useStyles();
  const [openCalculator,setOpenCalculator]=React.useState(false)
  const [changingPlanLevel,setChangingPlanLevel]=React.useState(false)

  function handleUpdateFree(){
    var setBillingsPlanLevel = firebase.fn.httpsCallable('setBillingsPlanLevel')
    setChangingPlanLevel(true)
    setBillingsPlanLevel({
      planLevel:"FREE",
      companyId:activeCompany.id,
    }).then((result)=>{
      console.log("result setBillingsPlanLevel",result)
      setChangingPlanLevel(false)
      if(!!onClose)onClose()
    }).catch(e=>{
      setChangingPlanLevel(false)
      window.alert("Gagal : "+e)
    })
  }

  function handleUpdateBasic(){
    var setBillingsPlanLevel = firebase.fn.httpsCallable('setBillingsPlanLevel')
    setChangingPlanLevel(true)
    setBillingsPlanLevel({
      planLevel:"BASIC",
      companyId:activeCompany.id,
    }).then((result)=>{
      console.log("result setBillingsPlanLevel",result)
      setChangingPlanLevel(false)
      if(!!onClose)onClose()
    }).catch(e=>{
      setChangingPlanLevel(false)
      window.alert("Gagal : "+e)
    })
  }

  function handleUpdatePro(){
    setOpenCalculator(false)
    var setBillingsPlanLevel = firebase.fn.httpsCallable('setBillingsPlanLevel')
    setChangingPlanLevel(true)
    setBillingsPlanLevel({
      planLevel:"PRO",
      companyId:activeCompany.id,
    }).then((result)=>{
      console.log("result setBillingsPlanLevel",result)
      setChangingPlanLevel(false)
      if(!!onClose)onClose()
    }).catch(e=>{
      setChangingPlanLevel(false)
      window.alert("Gagal : "+e)
    })
  }
  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth={true}
        maxWidth="xl"
        onClose={onClose}
      >
        <DialogTitle>{changingPlanLevel?"Memperbarui...":"Pilih Plan Level"}<IconButton style={{float:"right"}} onClick={()=>{if(!!onClose)onClose()}}><CloseIcon/></IconButton>{changingPlanLevel&&<LinearProgress />}</DialogTitle>
        <DialogContent>
          <ComparePricing open={true} selectedTier={selectedTier} disabled={changingPlanLevel} onRequestFree={handleUpdateFree} onRequestBasic={handleUpdateBasic} requestCalculator={()=>setOpenCalculator(true)}/>
        </DialogContent>
      </Dialog>
    <CalculatorPricingDialog open={openCalculator} width={width} selectedTier={selectedTier} onClose={()=>setOpenCalculator(false)} onRequestPro={handleUpdatePro}/>
    </>
  )
}

function CalculatorPricingDialog(props){
  const {
    open,
    onClose,
    width,
    selectedTier,
    onRequestPro,
    //...otherProps
  }=props
  const classes = useStyles();
  const [usageTurnOver,setUsageTurnOver]=React.useState(0)
  const [usageTransactionSell,setUsageTransactionSell]=React.useState(0)
  const [usageUnitEntry,setUsageUnitEntry]=React.useState(0)
  
  
  const [priceFree,setPriceFree]=React.useState(0)
  const [priceBasic,setPriceBasic]=React.useState(0)
  const [pricePro,setPricePro]=React.useState(0)
  const [requireBasic,setRequireBasic]=React.useState(false)
  const [requirePro,setRequirePro]=React.useState(false)

  
  const [openSummaryPro,setOpenSummaryPro]=React.useState(true)
  const [calcPriceAdditional,setCalcPriceAdditional]=React.useState(0)
  const [calcPriceTurnOver,setCalcPriceTurnOver]=React.useState(0)
  const [calcPriceTransactionSell,setCalcPriceTransactionSell]=React.useState(0)
  const [calcPriceUnitEntry,setCalcPriceUnitEntry]=React.useState(0)

  React.useEffect(()=>{
    var priceAdditional=0
    if(usageTurnOver>50000000||usageTransactionSell>500||usageUnitEntry>500){
      setRequirePro(true)
      setRequireBasic(true)
      setPriceBasic(500000)
      setPriceFree(0)
      priceAdditional=500000
    }else if(usageTurnOver>10000000||usageTransactionSell>100||usageUnitEntry>100){
      setRequirePro(false)
      setRequireBasic(true)
      setPriceBasic(500000)
      setPriceFree(0)
      priceAdditional=500000
    }else{
      setRequirePro(false)
      setRequireBasic(false)
      setPriceBasic(0)
      setPriceFree(0)
      priceAdditional=0
    }
    var priceTurnOver=Math.trunc((usageTurnOver-50000000)*0.01)
    if(priceTurnOver<0)priceTurnOver=0
    var priceTransactionSell=Math.trunc((usageTransactionSell-500)*1000)
    if(priceTransactionSell<0)priceTransactionSell=0
    var priceUnitEntry=Math.trunc((usageUnitEntry-500)*1000)
    if(priceUnitEntry<0)priceUnitEntry=0
    
    setPricePro(priceAdditional+priceTurnOver+priceTransactionSell+priceUnitEntry)

    setCalcPriceAdditional(priceAdditional)
    setCalcPriceTurnOver(priceTurnOver)
    setCalcPriceTransactionSell(priceTransactionSell)
    setCalcPriceUnitEntry(priceUnitEntry)
  },[usageTurnOver,usageTransactionSell,usageUnitEntry])

  const markOmzet = [
    {
      value: 0,
      label: '0',
    },
    {
      value: 10000000,
      label: 'FREE',
    },
    {
      value: 50000000,
      label: 'BASIC',
    },
  ];
  const marks = [
    {
      value: 0,
      label: '0',
    },
    {
      value: 100,
      label: 'FREE',
    },
    {
      value: 500,
      label: 'BASIC',
    },
  ];
  function getSimplifiedNumberFormat(value) {
    if(value>=1000&&value<999999){
      return Math.trunc(value/1000)+"K"
    }else if(value>=1000000&&value<999999999){
      return Math.trunc(value/1000000)+"Jt"
    }else{
      return value||0;
    }
  }
  

  function resetFreeLevel(){
    setUsageTurnOver(0)
    setUsageTransactionSell(0)
    setUsageUnitEntry(0)
  }

  return (
    <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition}>
      <AppBar className={classes.calculatorAppBar}>
        <Toolbar>
          <IconButton edge="start" autoFocus color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.calculatorTitle}>
            Kalkulator Skema Tarif
          </Typography>
          {selectedTier!=="PRO"&&
            <Button color="inherit" onClick={!!onRequestPro?onRequestPro:null}>
              UPGRADE PRO
            </Button>
          }
          
        </Toolbar>
      </AppBar>
      <div style={{backgroundColor:"#efefef"}}>
        <Grid container>
          <Grid item xs={12} sm={5}>
            <Paper className={classes.paper}>
              <Typography variant="h6">Contoh Pemakaian <Button style={{margin:"10px",float:"right"}} variant="contained" color="primary" onClick={resetFreeLevel}>RESET</Button></Typography>
              <div style={{clear:"both"}}>
                <span style={{float:"left",width:"50%",fontSize:"16px",fontWeight:"bold"}}>Omzet per bln</span>
                <span style={{float:"right",width:"50%",fontSize:"24px",textAlign:"right"}}>{numberToRupiah(usageTurnOver)}</span>
                <PrettoSliderActive valueLabelFormat={getSimplifiedNumberFormat} style={{clear:"both",width:"100%"}} valueLabelDisplay="auto" marks={markOmzet} max={100000000} aria-label="pretto slider" value={usageTurnOver} onChange={(ev,number)=>setUsageTurnOver(number)} />
                &nbsp;
              </div>
              <div>
                <span style={{float:"left",width:"50%",fontSize:"16px",fontWeight:"bold"}}>Transaksi Penjualan per bln</span>
                <span style={{float:"right",width:"50%",fontSize:"24px",textAlign:"right"}}>{usageTransactionSell}</span>
                <PrettoSliderActive valueLabelFormat={getSimplifiedNumberFormat} style={{clear:"both",width:"100%"}} valueLabelDisplay="auto" marks={marks} max={1000} aria-label="pretto slider" value={usageTransactionSell} onChange={(ev,number)=>setUsageTransactionSell(number)} />
                &nbsp;
              </div>
              <div>
                <span style={{float:"left",width:"50%",fontSize:"16px",fontWeight:"bold"}}>Transaksi Unit Entry per bln</span>
                <span style={{float:"right",width:"50%",fontSize:"24px",textAlign:"right"}}>{usageUnitEntry}</span>
                <PrettoSliderActive valueLabelFormat={getSimplifiedNumberFormat} style={{clear:"both",width:"100%"}} valueLabelDisplay="auto" marks={marks} max={1000} aria-label="pretto slider" value={usageUnitEntry} onChange={(ev,number)=>setUsageUnitEntry(number)} />
                &nbsp;
              </div>
              
            </Paper>
          </Grid>

          <Grid item xs={12} sm={7}>
            <Paper className={classes.paper}>
              <Accordion expanded={openSummaryPro} onChange={()=>{setOpenSummaryPro(!openSummaryPro)}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                >
                  <Typography variant="h6">Perbandingan Tarif</Typography>
                </AccordionSummary>
                <AccordionDetails style={{maxWidth:width==="xs"?"260px":"100%",overflowX:"auto"}}>
                  <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell><span style={{fontWeight:"bold"}}>Level</span></TableCell>
                          <TableCell align="right"><span style={{fontWeight:"bold"}}>Tarif per bulan</span></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            <span style={{fontSize:"16px",fontWeight:"bold",fontStyle:requirePro||requireBasic?"italic":"normal",color:requirePro||requireBasic?"red":"black",textDecoration:requirePro||requireBasic?"line-through":"none"}}>FREE</span>
                          </TableCell>
                          <TableCell align="right"><span style={{fontSize:"20px",fontWeight:"bold",fontStyle:requirePro||requireBasic?"italic":"normal",color:requirePro||requireBasic?"red":"black",}}>{requirePro||requireBasic?"Tidak Didukung":"FREE"}</span></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            <span style={{fontSize:"16px",fontWeight:"bold",fontStyle:requirePro?"italic":"normal",color:requirePro?"red":"black",textDecoration:requirePro?"line-through":"none"}}>BASIC</span>
                          </TableCell>
                          <TableCell align="right"><span style={{fontSize:"20px",fontWeight:"bold",fontStyle:requirePro?"italic":"normal",color:requirePro?"red":"black",}}>{requirePro?"Tidak Didukung":priceBasic<=0?"FREE":numberToRupiah(priceBasic)}</span></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                          <span style={{fontSize:"16px",fontWeight:"bold",fontStyle:"normal",color:"black",textDecoration:"none"}}>PRO</span>
                          </TableCell>
                          <TableCell align="right"><span style={{fontSize:"20px",fontWeight:"bold",fontStyle:"normal",color:"black",textDecoration:"none"}}>{pricePro<=0?"FREE":numberToRupiah(pricePro)}</span></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
              
              
              <PricingProDetail usage={{
                expanded:openSummaryPro,
                onChange:()=>{setOpenSummaryPro(!openSummaryPro)},
                planLevel:"PRO",
                usageTurnOver:usageTurnOver,
                usageTransactionSell:usageTransactionSell,
                usageUnitEntry:usageUnitEntry,
                amountBills:pricePro,
              }} width={width}/>
              
            </Paper>
          </Grid>
          
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Typography variant="h6">Limit dan Kuota</Typography>
              <TableContainer component={Paper}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell><span style={{fontWeight:"bold"}}></span></TableCell>
                      <TableCell><PlanLevelBadge plan="FREE"/></TableCell>
                      <TableCell><PlanLevelBadge plan="BASIC"/></TableCell>
                      <TableCell><PlanLevelBadge plan="PRO"/></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Kuota Omzet</TableCell>
                      <TableCell>Kuota omzet 10Jt/bln</TableCell>
                      <TableCell>Kuota omzet 50Jt/bln<br/><i>(Gratis 10Jt pertama)</i></TableCell>
                      <TableCell>Kuota omzet Unlimited<br/><i>(Gratis 10Jt pertama)<br/>(Diskon kuota omzet 50Jt tiap bulan)</i></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Limit Penjualan</TableCell>
                      <TableCell>100 transaksi/bln</TableCell>
                      <TableCell>500 transaksi/bln<br/><i>(Gratis 100 transaksi pertama)</i></TableCell>
                      <TableCell>Unlimited<br/><i>(Gratis 100 transaksi pertama)<br/>(Diskon 500 transaksi tiap bulan)</i></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Limit Unit Entry</TableCell>
                      <TableCell>100 unit/bln</TableCell>
                      <TableCell>500 unit/bln<br/><i>(Gratis 100 unit pertama)</i></TableCell>
                      <TableCell>Unlimited<br/><i>(Gratis 100 unit pertama)<br/>(Diskon 500 unit tiap bulan)</i></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Limit Karyawan</TableCell>
                      <TableCell>5 Karyawan</TableCell>
                      <TableCell>50 Karyawan</TableCell>
                      <TableCell>Unlimited</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Fitur Tambah Cabang</TableCell>
                      <TableCell>Tidak</TableCell>
                      <TableCell>Ya</TableCell>
                      <TableCell>Ya</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Fitur Custom Domain</TableCell>
                      <TableCell>Tidak</TableCell>
                      <TableCell>Tidak</TableCell>
                      <TableCell>Ya</TableCell>
                    </TableRow>

                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
      </div>
      
    </Dialog>
  )
}

function ComparePricing(props){
  const {
    style,
    open,
    disabled,
    selectedTier="FREE",
    onRequestFree,
    onRequestBasic,
    requestCalculator,
    //data,
  //...otherProps
  }=props
  const classes = useStyles();
  const tiers = [
    {
      title: 'FREE',
      subheader: 'Perusahaan Startup',
      price: 'Rp 0',
      description: [
        'Fitur Dasar',
        '1 Kantor Cabang',
        'Max 5 Karyawan', 
        'Limit Omzet Rp 10jt/bln', 
        'Kuota Penjualan 100 Transaksi/bln',
        'Kuota Unit Entry 100 Unit/bln',
      ],
      buttonText: 'Downgrade',
      buttonVariant: 'contained',
      buttonPrimaryOnClick:onRequestFree,
    },
    {
      title: 'BASIC',
      subheader: 'Perusahaan Berkembang',
      price: 'Rp 500K',
      description: [
        'Fitur Dasar',
        'Fitur Tambah Cabang',
        'Max 50 Karyawan/Cabang',
        'Limit Omzet Rp 50jt/bln', 
        'Kuota Penjualan 500 Transaksi/bln',
        'Kuota Unit Entry 500 Unit/bln',
        'Gratis Kuota Tiap Bulan',  
      ],
      buttonText: selectedTier==="PRO"?'Downgrade':'Upgrade',
      buttonVariant: 'contained',
      buttonPrimaryOnClick:onRequestBasic,
    },
    {
      title: 'PRO',
      subheader: 'Perusahaan Berskala Besar',
      price: 'Rp 1%',
      description: [
        'Fitur Premium',
        'Fitur Custom Domain',
        'Jumlah Cabang Baru Unlimited',
        'Jumlah Karyawan Unlimited',
        'Kuota Omzet Unlimited', 
        'Kuota Penjualan Unlimited',
        'Kuota Unit Entry Unlimited',
        'Gratis Kuota Tiap Bulan',     
      ],
      buttonText: 'Lihat Kalkulator Tarif',
      buttonVariant: 'contained',
      buttonPrimaryOnClick:requestCalculator,
      enabled:true,
      color:"secondary",
    },
    
  ];
  if(!open)return null
  return (
    
      <Grid container spacing={5} alignItems="flex-start">
        {tiers.map((tier) => (
          // Enterprise card is full width at sm breakpoint
          <Grid item key={tier.title} xs={12} sm={tier.title === 'Pro' ? 12 : 6} md={4}>
            <Card>
              <CardHeader
                title={tier.title}
                subheader={tier.subheader}
                titleTypographyProps={{ align: 'center' }}
                subheaderTypographyProps={{ align: 'center' }}
                action={tier.title === 'PRO' ? <StarIcon /> : null}
                className={classes.cardHeader}
              />
              <CardContent>
                <div className={classes.cardPricing}>
                  <Typography component="h2" variant="h3" color="textPrimary">
                    {tier.price}
                  </Typography>
                  <Typography variant="h6" color="textSecondary">
                    /bln
                  </Typography>
                </div>
                <ul>
                  {tier.description.map((line) => (
                    <Typography component="li" variant="subtitle1" align="left" key={line}>
                      {line}
                    </Typography>
                  ))}
                </ul>
              </CardContent>
              <CardActions>
                <Button fullWidth variant={selectedTier===tier.title?"outlined":"contained"} color={!!tier.color?tier.color:selectedTier===tier.title?"secondary":"primary"} disabled={disabled||(selectedTier===tier.title&&!tier.enabled)} onClick={tier.buttonPrimaryOnClick}>
                  {selectedTier===tier.title?"AKTIF":tier.buttonText}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    
  )
}

function numberToRupiah(number){
  var res=""+(!!parseInt(number)?parseInt(number):0)
  var arr=res.split("")
  arr.reverse()
  var len=Math.trunc(arr.length /3)
  if(len>=1){
    var temp=""
    for(var i=0;i<arr.length;i++){
      if(i>0 && i % 3 === 0){
        temp= arr[i]+"."+temp
      }else{
        temp= arr[i]+temp
      }
    }
    res=temp
  }
  if(res.length<11){
    var add=11-res.length
    for(var i=0;i<add;i++){
      res=" "+res
    }
  }
  return "Rp "+res+",00"
}

const condition = authUser => !!authUser;
export default withAuthDomain(condition,false,"online-asset-manager","")(withWidth()(CompanyBillingsPage));
export {PricingProDetail,PricingNonProDetail,CalculatorPricingDialog,numberToRupiah,PlanLevelBadge}